import { IParishBasic } from '../models/MainLayout/ParishBasic';
import { api } from 'boot/axios';

export class CurrentParish {
  parish: IParishBasic;

  constructor(p: IParishBasic) {
    this.parish = p;
  }

  public static async getInstance(): Promise<CurrentParish> {
      const parishResponse = await api.get<IParishBasic>('/api/parishes/current');
      return new CurrentParish(parishResponse.data);
  }

  public get() : IParishBasic {
    return this.parish;
  }  
}
